import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProcessingExceptions from './ProcessingExceptions';
import PayeeCommunicationExceptions from './PayeeCommunicationExceptions';
import { checkPermission } from '@/views/Facilities/CheckPermissions';
import { ErrorPage } from '@/views/Facilities/CheckPermissions';

const Exceptions = ({ role }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const canViewProcessingExceptions = checkPermission({
    parentKey: 'exceptions',
    childKey: 'processing_exceptions',
    permission: 'read',
  });
  const canViewPayeeCommunicationExceptions = checkPermission({
    parentKey: 'exceptions',
    childKey: 'payee_communication_exceptions',
    permission: 'read',
  });

  const hasVisibleTabs =
    canViewProcessingExceptions || canViewPayeeCommunicationExceptions;

  useEffect(() => {
    let visibleTabCount = 0;
    if (canViewProcessingExceptions) visibleTabCount++;
    if (canViewPayeeCommunicationExceptions) visibleTabCount++;

    if (activeTab >= visibleTabCount) {
      setActiveTab(0);
    }
  }, [
    canViewProcessingExceptions,
    canViewPayeeCommunicationExceptions,
    activeTab,
  ]);

  const renderContent = () => {
    if (!hasVisibleTabs) return null;

    let tabIndex = 0;
    if (canViewProcessingExceptions) {
      if (activeTab === tabIndex) {
        return <ProcessingExceptions role={role} />;
      }
      tabIndex++;
    }
    if (canViewPayeeCommunicationExceptions) {
      if (activeTab === tabIndex) {
        return <PayeeCommunicationExceptions role={role} />;
      }
    }
    return null;
  };

  return (
    <Card>
      <CardHeader
        style={{ display: 'flex', justifyContent: 'space-between' }}
        color='primary'>
        <h4>{t('exceptions.title')}</h4>
      </CardHeader>
      <CardBody>
        {hasVisibleTabs ? (
          <Tabs value={activeTab} onChange={handleTabChange}>
            {canViewProcessingExceptions && (
              <Tab label={t('exceptions.tabs.processingExceptions')} />
            )}
            {canViewPayeeCommunicationExceptions && (
              <Tab label={t('exceptions.tabs.payeeCommunicationExceptions')} />
            )}
          </Tabs>
        ) : (
          <ErrorPage childKey='exceptions' />
        )}
        {renderContent()}
      </CardBody>
    </Card>
  );
};

export default Exceptions;
